<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    class="pa-5"
  >
    <!-- pass through scoped slots -->
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <!-- pass through normal slots -->
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card class="d-flex flex-column">
      <v-toolbar color="primary" class="shrink">
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Custom Print Extractor</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn v-if="selectedSide" text @click="printSVG">{{ $t('Print SVG') }}</v-btn>
          <v-btn v-else text @click="extractPrint">{{ $t('Extract') }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        top
        color="white"
      ></v-progress-linear>
      <v-container class="fill-height text-start" style="opacity: 0.94" fluid>
        <v-sheet elevation="1" rounded width="100%" class="mb-8">
          <template>
            <v-tabs bg-color="indigo-darken-2" fixed-tabs v-model="selectedSide">
              <v-tab>FRONT</v-tab>
              <v-tab>BACK</v-tab>
            </v-tabs>

            <v-tabs-items v-model="selectedSide">
              <v-tab-item>
                <div>
                  <v-row justify="space-around" class="py-5 px-12">
                    <v-col cols="4" class="text-end">
                      <v-form>
                        <v-tabs v-model="selectedTab" class="mb-3">
                          <v-tab
                            v-for="tab in tabs"
                            :key="tab.value"
                            style="text-transform: none"
                            :value="tab.value"
                          >
                            {{ tab.label }}
                          </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="selectedTab">
                          <v-tab-item>
                            <v-list class="mb-5" outlined nav>
                              <v-list-item-group v-model="printType" color="primary">
                                <v-row justify="start" class="flex-column">
                                  <v-col cols="12" class="p-2">
                                    <v-list-item
                                      v-for="type in printTypes"
                                      :key="type.id"
                                      :value="type.value"
                                      class="p-16-0"
                                    >
                                      {{ type.label }}
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-list-item-group>
                            </v-list>
                          </v-tab-item>
                          <v-tab-item>
                            <v-textarea outlined v-model="prompt" rows="8"></v-textarea>
                            <v-list class="mb-5" outlined nav>
                              <v-list-item-group v-model="model" color="primary">
                                <v-row justify="start" class="flex-column">
                                  <v-col cols="12" class="p-2">
                                    <v-list-item
                                      v-for="model in models"
                                      :key="model.id"
                                      :value="model.value"
                                      class="p-16-0"
                                    >
                                      {{ model.label }}
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-list-item-group>
                            </v-list>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-form>
                    </v-col>
                    <v-col cols="8">
                      <v-list outlined nav>
                        <v-subheader
                          style="
                            font-size: 1rem;
                            font-weight: 500;
                            display: flex;
                            justify-content: space-between;
                            border-bottom: 1px solid white;
                          "
                          >Preview {{ responseTime && `(${responseTime})` }}
                          <v-btn
                            text
                            size="small"
                            class="text-capitalize"
                            v-if="this.$props.metafieldImages?.length"
                            @click="metafieldImagesDialog = true"
                          >
                            Metafield Images ({{ this.$props.metafieldImages.length }})
                          </v-btn>
                          <v-dialog
                            v-model="metafieldImagesDialog"
                            hide-overlay
                            transition="dialog-bottom-transition"
                            class="pa-5"
                          >
                            <v-card class="d-flex flex-column">
                              <v-toolbar color="primary" class="shrink">
                                <v-btn icon @click="metafieldImagesDialog = false">
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Metafield Images</v-toolbar-title>
                              </v-toolbar>
                              <v-row class="pa-5">
                                <div
                                  v-for="(metafieldImage, index) in this.$props.metafieldImages"
                                  :key="index"
                                  class="pa-2"
                                >
                                  <v-img
                                    :src="metafieldImage"
                                    width="200px"
                                    @click="changeInputImage(metafieldImage)"
                                    style="cursor: pointer"
                                  />
                                </div>
                              </v-row>
                            </v-card>
                          </v-dialog>
                        </v-subheader>
                        <v-row>
                          <v-col cols="6">
                            <image-upload
                              @change="handleImageSelected"
                              :intialPreviewURL="intialPreviewURL"
                              :showDownloadButton="true"
                            />
                          </v-col>
                          <v-col cols="6" style="position: relative">
                            <v-btn
                              fab
                              style="position: absolute; z-index: 9999; right: 20px; top: 20px"
                              small
                              @click="downloadImage(previewSrc, '_front.png')"
                            >
                              <v-icon>mdi-cloud-download-outline</v-icon>
                            </v-btn>
                            <v-img :src="previewSrc" contain />
                          </v-col>
                        </v-row>
                      </v-list>
                    </v-col>
                  </v-row>
                  <div class="px-5" v-if="!!edits?.length">
                    <h4
                      style="
                        font-weight: 600;
                        font-size: 1.5rem;
                        margin-left: 1rem;
                        text-decoration: underline;
                        text-underline-offset: 0.5rem;
                      "
                    >
                      Extractions:
                    </h4>
                    <div style="display: flex; margin-bottom: 100px">
                      <v-img
                        v-for="edit in edits"
                        :key="edit"
                        @click="selectEdit(edit)"
                        :src="edit"
                        :style="`object-fit: cover; margin: 1rem; width: 15%; cursor: pointer;`"
                      />
                    </div>
                  </div>
                  <div class="px-5" v-if="!!originalGeminiEdits.length">
                    <h4
                      style="
                        font-weight: 600;
                        font-size: 1.5rem;
                        margin-left: 1rem;
                        text-decoration: underline;
                        text-underline-offset: 0.5rem;
                      "
                    >
                      Original Gemini Edits:
                    </h4>
                    <div style="display: flex; margin-bottom: 100px">
                      <v-img
                        v-for="edit in originalGeminiEdits"
                        :key="edit"
                        @click="selectEdit(edit)"
                        :src="edit"
                        :style="`object-fit: cover; margin: 1rem; width: 15%; cursor: pointer;`"
                      />
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item>
                <v-row justify="center" class="py-5 px-12" gap="500px">
                  <v-col cols="4" class="text-end">
                    <v-text-field
                      v-model="line1"
                      hide-details
                      required
                      outlined
                      clearable
                      class="mb-4"
                    >
                      <template #label> Line 1 </template>
                    </v-text-field>
                    <v-text-field
                      v-model="line2"
                      hide-details
                      required
                      outlined
                      clearable
                      class="mb-4"
                    >
                      <template #label> Line 2 </template>
                    </v-text-field>
                    <v-text-field
                      v-model="line3"
                      hide-details
                      required
                      outlined
                      clearable
                      class="mb-4"
                    >
                      <template #label> Line 3 </template>
                    </v-text-field>
                    <v-select
                      :items="[
                        { label: 'Modern', value: 'modern' },
                        { label: 'Classic', value: 'classic' },
                        { label: 'Italic', value: 'italic' },
                      ]"
                      item-text="label"
                      item-value="value"
                      v-model="selectedFont"
                      outlined
                      clearable
                    >
                      <template #label>
                        {{ $t('Font') }}
                        <span class="red--text"><strong>*</strong></span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="4" class="text-center">
                    <div
                      width="256px"
                      height="256px"
                      style="display: inline-flex; position: relative"
                    >
                      <v-btn
                        fab
                        style="position: absolute; z-index: 9999; right: 8px; top: 8px"
                        small
                        @click="downloadImage(svgSrc, '_back.svg')"
                      >
                        <v-icon>mdi-cloud-download-outline</v-icon>
                      </v-btn>
                      <v-img :src="svgSrc" contain width="256px" style="background-color: #fff" />
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </v-sheet>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import ImageUpload from '../components/ImageUpload.vue'
  import prompts from '@/assets/mizodia/custom-print-prompts.json'
  import { createTextSvg, generateEdits, generateEditsAndProcess } from '../services/pdfGenerationService'
  const EDITS_PER_REQUEST = 3

  export default {
    props: [
      'title',
      'data',
      'store',
      'type',
      'image',
      'fileName',
      'lines',
      'font',
      'metafieldImages',
    ],
    data() {
      return {
        dialog: false,
        metafieldImagesDialog: false,
        previewOriginal: 'https://placehold.co/200x300',
        previewSrc: 'https://placehold.co/200x300',
        svgSrc: 'https://placehold.co/256x256',
        intialPreviewURL: 'https://placehold.co/200x300',
        loading: false,
        selectedImage: null,
        edits: [],
        originalGeminiEdits: [],
        selectedSide: 0,
        selectedTab: 0,
        tabs: [
          { label: 'Predefined', value: 0 },
          { label: 'Custom Prompt', value: 1 },
        ],
        printType: 'fingerprint',
        prompt: prompts['fingerprint'],
        printTypes: [
          { label: 'Fingerprint', value: 'fingerprint' },
          { label: 'Nose Print', value: 'pet_nose_print' },
          { label: 'Paw Print', value: 'pet_paw_print' },
          { label: 'Baby Hands', value: 'baby_hands' },
          { label: 'Baby Feet', value: 'baby_feet' },
          { label: 'Handwriting', value: 'handwriting' },
        ],
        model: 'gemini-2.5-flash-image',
        models: [
          { label: 'Gemini 2.5', value: 'gemini-2.5-flash-image' },
          { label: 'Gemini 3', value: 'gemini-3-pro-image-preview' },
        ],
        responseTime: null,
        line1: '',
        line2: '',
        line3: '',
        selectedFont: 'modern',
      }
    },
    methods: {
      changeInputImage(image) {
        this.intialPreviewURL = image
        this.metafieldImagesDialog = false
      },
      selectEdit(edit) {
        this.previewSrc = edit
      },
      handleImageSelected(file) {
        if (file) {
          this.selectedImage = file
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewOriginal = e.target.result
          }
          reader.readAsDataURL(file)
        }
      },
      async extractPrint() {
        this.loading = true
        try {
          const reader = new FileReader()
          const fileLoaded = new Promise((resolve, reject) => {
            reader.onloadend = () => {
              if (reader.result) {
                const result = reader.result
                resolve(result.split(',')[1])
              } else reject('Failed to read file')
            }
          })
          reader.readAsDataURL(this.selectedImage)
          const base64Image = await fileLoaded
          const predefinedTab = this.selectedTab === 0
          const model = this.model
            let prompt = predefinedTab ? prompts[this.printType] : this.prompt
          prompt +=
            model === this.models[0].value
              ? `Generate ${EDITS_PER_REQUEST} different edits for this.`
              : `You must generate ${EDITS_PER_REQUEST} edited versions of the input image, return exactly ${EDITS_PER_REQUEST} separate response parts, each containing only one edited image with no text, no combined images, no grouping; the output must be a sequence of ${EDITS_PER_REQUEST} independent image parts, and you must not put multiple images in one part or produce a collage.`
          const fetchEdits = ['baby_feet'].includes(this.printType)
            ? generateEditsAndProcess
            : generateEdits

          let type = (this.selectedImage.type || this.selectedImage.name?.split('.').slice(-1)[0])?.toLowerCase()
          type = type.startsWith('image/') ? type : `image/${type}`
          
          const response = await fetchEdits(model, prompt, base64Image, type, this.$props.data.orderNumber)
          console.log('response:', response)

          const data = response?.data
          if (data?.success) {
            console.log(data.data.edits)
            const edits = data.data.edits.map((edit) => edit.url)
            this.previewSrc = edits?.[0]
            this.edits = edits
            this.originalGeminiEdits = (data.data.originalGeminiEdits || []).map((edit) => edit.url)
            this.responseTime =
              (parseInt(data.responseTime.replace('ms', '')) / 1000).toFixed(2) + 's'
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
          const audio = new Audio(
            'https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'
          )
          audio.play() // to notify the distracted user that your async request is complete
        }
      },
      async printSVG() {
        if ((!this.line1 && !this.line2 && !this.line3) || !this.selectedFont) {
          return
        }

        this.loading = true
        try {
          const { data } = await createTextSvg(
            {
              lines: [this.line1, this.line2, this.line3]
                .filter((line) => line.trim() !== '')
                .map((line) => ({ text: line, fontStyle: this.selectedFont })),
              options: { width: 256, fontSize: 24 },
            },
            `${Date.now()}_${this.$props.fileName}_back.svg`
          )

          if (data?.data?.url) {
            console.log(data.data.url)
            this.svgSrc = data.data.url
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },

      async downloadImage(src, fileSuffix) {
        const link = await this.linkToObjectUrl(src)
        // Create a download link
        const downloadLink = document.createElement('a')
        downloadLink.href = link
        downloadLink.download = `${this.$props.fileName}${fileSuffix}`
        downloadLink.click()
      },
      async linkToObjectUrl(link) {
        const response = await fetch(link)
        const blob = await response.blob()
        return URL.createObjectURL(blob)
      },
    },
    watch: {
      dialog: {
        handler: async function (val) {
          if (val === false) return

          this.printType = this.$props.type === 'other' ? 'fingerprint' : this.$props.type
          this.selectedFont =
            { Roboto: 'modern', 'Roboto Slab': 'classic', 'Dancing Script': 'italic' }[
              this.$props.font
            ] || 'modern'
          this.line1 = this.lines[0]
          this.line2 = this.lines[1]
          this.line3 = this.lines[2]
          await this.printSVG()
        },
      },

      printType() {
        this.prompt = prompts[this.printType]
      },
    },
    components: { ImageUpload },
    mounted() {
      this.intialPreviewURL = this.$props.image
    },
  }
</script>
